<div class="card-block card-body mt-2 pb-1 pt-1 card-primary" >
    <ag-grid-angular #agGrid style="width: 100%; height: 250px"  id="personDocuSignStatusTable" [rowData]="rowData" class="ag-theme-balham"
        [columnDefs]="columnDefs" [enableSorting]="true" [enableColResize]="true"
        [enableRangeSelection]="true" [paginationPageSize]="10" [pagination]="true" (columnResized)="onColumnResized($event)"
        (gridReady)="onGridReady($event)" [suppressMenuHide]="true"  [overlayLoadingTemplate]="overlayLoadingTemplate"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate">
    </ag-grid-angular>
</div>